// reportRenderers.js
import React from "react";

// Export all renderer functions
export const reportRenderers = {
  // Vendor Due Amount Report Renderers
  renderLastPurchasedDetails: (row) => {
    return React.createElement('div', null,
      React.createElement('div', null, `Last Inventory Amount: ${row.LastInventoryAmount || '0'}`),
      React.createElement('div', null, `Last Inventory Date: ${row.LastInventoryDate ? new Date(row.LastInventoryDate).toISOString().split('T')[0] : '-'}`),
      React.createElement('div', null, `Last Inventory No: ${row.LastInventoryNo || '-'}`)
    );
  },

  renderLastExpenseDetails: (row) => {
    return React.createElement('div', null,
      React.createElement('div', null, `Last Expense Amount: ${row.LastExpenseAmount || '0'}`),
      React.createElement('div', null, `Last Expense Date: ${row.LastExpenseDate ? new Date(row.LastExpenseDate).toISOString().split('T')[0] : '-'}`),
      React.createElement('div', null, `Last Expense No: ${row.LastExpenseNo || '-'}`)
    );
  },

  // Add more renderers for other reports as needed
  renderProductDetails: (row) => {
    return React.createElement('div', { className: "product-details" },
      React.createElement('span', { className: "product-name" }, row.ProductName),
      React.createElement('span', { className: "product-code" }, ` (${row.ProductCode})`)
    );
  },

  renderCustomerInfo: (row) => {
    return React.createElement('div', null,
      React.createElement('div', null, row.CustomerName),
      React.createElement('div', { style: { fontSize: '12px', color: '#666' } }, row.CustomerCode)
    );
  },

  // Generic renderer for date formatting
  renderDate: (row, fieldName) => {
    const date = row[fieldName];
    if (!date) return '-';
    return new Date(date).toISOString().split('T')[0];
  },

  // Generic renderer for currency formatting
  renderCurrency: (row, fieldName, currencySymbol = '₹') => {
    const amount = row[fieldName];
    if (!amount && amount !== 0) return '-';
    return `${currencySymbol} ${Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
};

// Helper function to get renderer by name
export const getRenderer = (rendererName) => {
  return reportRenderers[rendererName] || null;
};